export default __webpack_public_path__ + "static/media/centro_andes_2_5.00ce286b.JPG";